import {kebabCase} from 'lodash';

/**
 * Background class for a classroom's subject-domain color: first subject
 * (alphabetically) → curriculum area → `background-domain-*`, brand fallback.
 * Requires the classroom to include `subjects_v2.curriculum_area_v1`.
 */
export const getClassroomDomainBackgroundClass = (classroom?: any): string => {
  const subjects = classroom?.getSubjects?.();
  if (!subjects || subjects.isEmpty?.()) return 'background-brand';

  const sorted = subjects.sortBy?.((s) => s.getName?.()) ?? subjects;
  const firstSubject = sorted.first?.();
  const curriculumArea = firstSubject?.getCurriculumArea?.();

  if (!curriculumArea || curriculumArea.isEmpty?.()) return 'background-brand';

  return `background-domain-${kebabCase(curriculumArea.getName())}`;
};
